export default __webpack_public_path__ + "static/media/Slot.f7c9fb2d.wav";